import { BatteryAlertIcon } from './BatteryAlertIcon';

/**
 * author: Google
 * id ABFAD078-0E10-4293-94AD-16871B75E51F
 * name battery-alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-alert.svg
 * tags
 * - Battery 
 * - Home Automation 
 * - Alert / Error 
 */
export const BatteryWarningIcon = BatteryAlertIcon;
export default BatteryWarningIcon